var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-center bg-no-repeat bg-cover text-white",staticStyle:{"height":"40px","background-color":"#04aade"}},[_c('div',{staticClass:"flex items-center justify-center pt-2 font-bold"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }